import Vue from 'vue';

import 'normalize.css';
import * as VueGoogleMaps from 'vue2-google-maps';
// import {GmapMarker} from 'vue2-google-maps/src/components/marker';
import SvgIcon from 'vue-svgicon';
import ElementUI from 'element-ui';
import '@/styles/index.scss';
import '@/icons/components';
import '@/permission';
import 'babel-polyfill';

/**
 * This project originally used easy-mock to simulate data requests,
 * but its official service is not stable.
 * So here We use Mock.js for a local emulation,
 * it will intercept your request and you won't see the request in the network.
 * If you remove `import '../mock'` it will automatically request easy-mock data.
 */
import '../mock'; // simulation data requests

import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import '@/registerServiceWorker';
import i18n from './lang';
import * as filters from './filters'; // global filters


// Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAEGzjEhgJuiOFf3agSpRZRICO0MfsUjuk',
    libraries: 'places,drawing,visualization', // This is required if you use the Autocomplete plugin
  },
  installComponents: true,
});

Vue.use(ElementUI, {
  i18n: (key: string, options: any) => i18n.t(key, options),
});
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em',
});

// 注册全局筛选器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
